import React from 'react';
import ReactModal from 'react-modal';
import { createModal } from 'react-modal-promise';

const PurchaseLineItemPartialRefundModal = ({
  open,
  close,
  lineItemsToRefund,
}) => (
  <ReactModal
    appElement={document.getElementById('root')}
    isOpen={open}
    contentLabel="Minimal Modal Example"
    portalClassName="AdjustmentCreditPortal"
    overlayClassName="AdjustmentCreditModal__Overlay"
    className="AdjustmentCreditModal__Content"
  >
    <div className="modal-header">
      <span className="close" onClick={() => close(false)}>
        &times;
      </span>
      <h2>Refund these amounts:</h2>
      <table className="table table-striped">
        <thead>
          <tr>
            <th>ID</th>
            <th>Title</th>
            <th>Description</th>
            <th>Refund</th>
          </tr>
        </thead>
        <tbody className="text-danger">
          {lineItemsToRefund.map((item) => (
            <tr key={item.id}>
              <td>{item.id}</td>
              <td>{item.title}</td>
              <td>{item.description}</td>
              <td>(${item.full_refund ? item.price : item.refund_amount})</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
    <div className="modal-body">
      <p>Are you sure you want to refund this amount?</p>
    </div>
    <div className="modal-footer">
      <button className={'btn btn-primary'} onClick={() => close(true)}>
        Refund now
      </button>
      <button className={'btn'} onClick={() => close(false)}>
        Cancel
      </button>
    </div>
  </ReactModal>
);

export default createModal(PurchaseLineItemPartialRefundModal);
